import { formatValueWithCurrency } from 'src/utils/number/currency'
import formatDate from 'date-fns/format'
import addMilliseconds from 'date-fns/addMilliseconds'
import { intl } from 'src/i18n'

//TODO: check for translation

export const PriceColor = '#84c47c'
export const MCColor = '#FF8A00'
export const VolumeColor = '#777777'
export const INPUT_DATE_FORMAT = 'yyyy-MM-dd'
export const OVERSCROLL_PERCENT = 0.01
export const PriceSeriesName = intl.t(
  'components.coinChart.config.priceSeriesName'
)
export const LastPriceSeriesName = intl.t(
  'components.coinChart.config.lastPriceSeriesName'
)
export const LastMCSeriesName = intl.t(
  'components.coinChart.config.lastMCSeriesName'
)
export const MCSeriesName = intl.t('components.coinChart.config.mcSeriesName')
export const VolumeSeriesName = intl.t(
  'components.coinChart.config.volumeSeriesName'
)

export const ColorScheme = {
  BRIGHT: 'BRIGHT',
  DARK: 'DARK',
}

export const ChartFormat = {
  FULL: 'FULL',
  VERTICAL: 'VERTICAL',
  HORIZONTAL: 'HORIZONTAL',
}

export const chartPeriods = ['1D', '7D', '1M', '6M', '1Y', 'ALL']

const formatter = () =>
  function (value) {
    if ((this.value || value) < 0) {
      return ''
    }

    return (
      '$' +
      formatValueWithCurrency(
        this.value === undefined ? value : this.value,
        '',
        false,
        true
      )
    )
  }

const fontStyle = {
  fontFamily: "'Roboto', Arial, Helvetica, sans-serif",
  fontSfontStyleize: 12,
}

export const config = {
  chart: {
    panning: false,
    zoomType: 'x',
    pinchType: 'x',
    backgroundColor: 'transparent',
    spacingRight: 30,
    resetZoomButton: {
      theme: {
        display: 'none',
        visibility: 'hidden',
      },
    },
    animation: false,
  },
  plotOptions: {
    series: {
      turboThreshold: 4000,
      states: {
        hover: {
          enabled: false,
        },
        select: {
          enabled: false,
        },
        inactive: {
          enabled: false,
        },
      },
    },
  },
  navigator: {
    enabled: false,
  },
  scrollbar: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
    fallbackToExportServer: false,
  },
  yAxis: [
    {
      id: 'LastPrice',
      opposite: true,
      color: PriceColor,
      lineWidth: 1,
      lineColor: '#9f9fa0',
      tickAmount: 9,
      gridLineWidth: 0.5,
      gridLineColor: '#3f3f40',
      height: '90%',
      offset: -1,
      labels: {
        enabled: true,
        align: 'left',
        formatter: formatter(),
        y: 5,
        style: {
          ...fontStyle,
          color: PriceColor,
        },
        x: 7,
      },
      zIndex: 102,
    },
    {
      name: intl.t('components.coinChart.config.priceSeriesName'),
      opposite: true,
      color: PriceColor,
      lineWidth: 0,
      lineColor: '#3f3f40',
      tickAmount: 9,
      gridLineWidth: 0.5,
      gridLineColor: '#3f3f40',
      height: '90%',
      offset: -1,
      crosshair: {
        enabled: true,
        dashStyle: 'Dot',
        color: '#9f9fa0',
        width: 1,
        label: {
          enabled: true,
          formatter: formatter(false),
          backgroundColor: '#323333',
          shape: 'square',
          style: {
            ...fontStyle,
            zIndex: 110,
          },
        },
      },
      offset: -8,
      labels: {
        enabled: true,
        align: 'left',
        formatter: formatter(),
        y: 5,
        style: {
          ...fontStyle,
          color: 'transparent',
        },
      },
      zIndex: 100,
    },
    {
      name: intl.t('components.coinChart.config.lastMCSeriesName'),
      opposite: false,
      color: MCColor,
      lineWidth: 1,
      lineColor: '#9f9fa0',
      tickAmount: 9,
      gridLineWidth: 0.5,
      offset: -1,
      gridLineColor: '#3f3f40',
      height: '90%',
      labels: {
        align: 'right',
        formatter: formatter(),
        y: 5,
        style: {
          ...fontStyle,
          color: MCColor,
        },
      },
    },
    {
      name: intl.t('components.coinChart.config.mcSeriesName'),
      opposite: false,
      color: MCColor,
      lineWidth: 0,
      lineColor: '#3f3f40',
      tickAmount: 9,
      gridLineWidth: 0.5,
      gridLineColor: '#3f3f40',
      height: '90%',
      offset: -1,
      crosshair: {
        width: 0,
        enabled: false,
        dashStyle: 'Dot',
        label: {
          align: 'right',
          style: {
            ...fontStyle,
          },
          enabled: true,
          backgroundColor: '#323333',
          formatter: formatter(false),
          shape: 'square',
        },
      },
      labels: {
        align: 'right',
        formatter: formatter(),
        y: 5,
        style: {
          ...fontStyle,
          color: 'transparent',
        },
      },
    },
    {
      name: intl.t('components.coinChart.config.volumeSeriesName'),
      opposite: true,
      color: VolumeColor,
      lineWidth: 1,
      lineColor: '#9f9fa0',
      tickLength: 8,
      tickWidth: 0,
      tickPosition: 'outside',
      tickColor: '#1d1d1e',
      top: '85%',
      height: '15%',
      gridLineWidth: 0,
      offset: -1,
      crosshair: {
        width: 0,
        enabled: true,
        dashStyle: 'Dot',
        label: {
          enabled: true,
          formatter: formatter(),
          style: {
            ...fontStyle,
            zIndex: 115,
          },
          shape: 'square',
          zIndex: 115,
        },
      },
      labels: {
        enabled: false,
      },
      zIndex: 114,
    },
    {
      lineWidth: 1,
      lineColor: '#9f9fa0',
      opposite: false,
      top: '85%',
      height: '15%',
      offset: -1,
    },
  ],
  loading: {
    style: {
      background: '#6b6c6b',
      opacity: 0.9,
    },
  },
  time: {
    useUTC: true,
  },
  xAxis: [
    {
      lineWidth: 1,
      lineColor: '#9f9fa0',
      gridLineWidth: 0.5,
      gridLineColor: '#3f3f40',
      tickLength: 0,
      tickColor: '#3f3f40',
      crosshair: {
        dashStyle: 'Dot',
        enabled: true,
        color: '#9f9fa0',
        width: 1,
        label: {
          enabled: true,
          backgroundColor: '#282a29',
          formatter: function (timestamp) {
            const diff = (this.dataMax - this.dataMin) / 1000
            const timeZoneOffset = new Date().getTimezoneOffset() * 1000 * 60
            const d = addMilliseconds(new Date(timestamp), timeZoneOffset)

            if (diff < 60 * 60 * 24 * 7) {
              return formatDate(d, 'MMM dd, HH:mm')
            } else if (diff < 60 * 60 * 24 * 30 * 2) {
              return formatDate(d, 'yyyy, MMM dd, HH:mm')
            } else {
              return formatDate(d, 'yyyy, MMM dd')
            }
          },
        },
      },
      labels: {
        style: {
          ...fontStyle,
        },
      },
    },
  ],
  rangeSelector: {
    enabled: false,
    inputEnabled: false,
  },
  series: [
    {
      name: LastPriceSeriesName,
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            enabled: false,
          },
          normal: {
            enabled: false,
          },
          select: {
            enabled: false,
          },
        },
      },
      dataGrouping: {
        enabled: false,
      },
      yAxis: 0,
      lastPrice: {
        enabled: true,
        dashStyle: 'Dot',
        color: PriceColor,
        label: {
          enabled: true,
          backgroundColor: PriceColor,
          formatter: formatter(),
          zIndex: 110,
          shape: 'square',
        },
      },
      data: [],
      color: 'transparent',
      includeInDataExport: false,
      showInLegend: false,
    },
    {
      name: PriceSeriesName,
      zIndex: 2,
      yAxis: 1,
      color: PriceColor,
      data: [],
      dataGrouping: {
        enabled: false,
      },
      marker: {
        enabled: false,
        states: {
          hover: {
            radius: 4,
            lineWidth: 2,
            lineColor: '#fff',
          },
        },
        symbol: 'circle',
      },
      events: {
        hide: function () {
          const serie = this.chart.series.find(i => i.name === 'LastPrice')
          const priceAxis = this.chart.series.find(
            i => i.name === 'Price'
          ).yAxis

          serie.update({
            lastPrice: {
              enabled: false,
              label: {
                enabled: false,
              },
            },
          })

          priceAxis.update({
            crosshair: {
              enabled: false,
              label: {
                enabled: false,
              },
            },
          })

          serie.yAxis.update({
            labels: {
              style: {
                color: 'transparent',
              },
            },
          })

          if (serie.crossLabel) {
            serie.crossLabel
          }
        },
        show: function () {
          const serie = this.chart.series.find(i => i.name === 'LastPrice')
          const priceAxis = this.chart.series.find(
            i => i.name === 'Price'
          ).yAxis

          serie.update({
            lastPrice: {
              enabled: true,
              label: {
                enabled: true,
              },
            },
          })

          serie.yAxis.update({
            labels: {
              style: {
                color: PriceColor,
              },
            },
          })

          priceAxis.update({
            crosshair: {
              enabled: true,
              label: {
                enabled: true,
              },
            },
          })
        },
      },
    },
    {
      name: LastMCSeriesName,
      yAxis: 2,
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            enabled: false,
          },
          normal: {
            enabled: false,
          },
          select: {
            enabled: false,
          },
        },
      },
      lastPrice: {
        enabled: true,
        dashStyle: 'Dot',
        color: 'transparent',
        label: {
          enabled: true,
          backgroundColor: MCColor,
          formatter: formatter(),
          zIndex: 110,
          shape: 'square',
        },
      },
      data: [],
      color: 'transparent',
      includeInDataExport: false,
      showInLegend: false,
    },
    {
      name: MCSeriesName,
      yAxis: 3,
      color: MCColor,
      zIndex: 2,
      data: [],
      marker: {
        enabled: false,
        states: {
          hover: {
            radius: 4,
            lineWidth: 2,
            lineColor: '#fff',
          },
        },
        symbol: 'circle',
      },
      events: {
        hide: function () {
          const serie = this.chart.series.find(
            i => i.name === 'Last Market Cap'
          )
          const priceAxis = this.chart.series.find(
            i => i.name === 'Market Cap'
          ).yAxis

          serie.update({
            lastPrice: {
              enabled: false,
              label: {
                enabled: false,
              },
            },
          })

          priceAxis.update({
            crosshair: {
              enabled: false,
              label: {
                enabled: false,
              },
            },
          })

          serie.yAxis.update({
            labels: {
              style: {
                color: 'transparent',
              },
            },
          })

          if (serie.crossLabel) {
            serie.crossLabel
          }
        },
        show: function () {
          const serie = this.chart.series.find(
            i => i.name === 'Last Market Cap'
          )
          const priceAxis = this.chart.series.find(
            i => i.name === 'Market Cap'
          ).yAxis

          serie.update({
            lastPrice: {
              enabled: true,
              label: {
                enabled: true,
              },
            },
          })

          serie.yAxis.update({
            labels: {
              style: {
                color: MCColor,
              },
            },
          })

          priceAxis.update({
            crosshair: {
              enabled: true,
              label: {
                enabled: true,
              },
            },
          })
        },
      },
    },
    {
      name: VolumeSeriesName,
      yAxis: 4,
      data: [],
      zIndex: 1,
      color: VolumeColor,
      type: 'column',
      groupPadding: 0.1,
      crisp: false,
      dataGrouping: {
        groupPixelWidth: 5,
      },
      pointPlacement: -0.1,
    },
  ],
  tooltip: {
    backgroundColor: '#282a29',
    style: {
      ...fontStyle,
      color: '#fff',
    },
    split: true,
    shared: true,
    formatter: function () {
      return ['', '', '', '', '', '']
    },
  },
  legend: {
    enabled: true,
    itemStyle: {
      color: '#777',
    },
    itemHoverStyle: {
      color: '#999',
    },
    itemHiddenStyle: {
      color: '#333',
    },
  },
}

export default config
